import * as apiService from "./apiService";
import { ADMIN_WIDGETS } from "../../constants/v2/endPoints";

export async function createWidget(payload) {
  return await apiService.apiCall(ADMIN_WIDGETS, "POST", payload);
}

export async function listWidgets() {
  return await apiService.apiCall(ADMIN_WIDGETS, "GET");
}

export async function getWidget(id) {
  return await apiService.apiCall(`${ADMIN_WIDGETS}/${id}`, "GET");
}

export async function updateWidget(id, payload) {
  return await apiService.apiCall(`${ADMIN_WIDGETS}/${id}`, "PUT", payload);
}

export async function deleteWidget(id) {
  return await apiService.apiCall(`${ADMIN_WIDGETS}/${id}`, "DELETE");
}
